/* v8 ignore start -- @preserve */
import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge((config) => ({
  ...config,
  classGroups: {
    ...config.classGroups,

    typography: [
      "heading-1",
      "heading-2",
      "heading-3",
      "heading-4",
      "heading-5",
      "heading-6",
      "body-extra-large-semibold",
      "body-extra-large-medium",
      "body-extra-large-regular",
      "body-large-semibold",
      "body-large-medium",
      "body-large-regular",
      "body-semi-large-semibold",
      "body-semi-large-medium",
      "body-semi-large-regular",
      "body-base-semibold",
      "body-base-medium",
      "body-base-regular",
      "body-small-semibold",
      "body-small-medium",
      "body-small-regular",
      "body-extra-small-semibold",
      "body-extra-small-medium",
      "body-extra-small-regular",
      "rich-link",
      "rich-link-medium",
      "rich-link-regular",
      "rich-link-small-medium",
      "rich-link-small-regular",
    ],
  },
}));

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

export const cnTwMerge = cn;
